import { rodnecislo } from "rodnecislo";
import { TFunction } from "i18next";
import { lenCheck } from "@/utils/validations/helpers";

export const isIcoValid = (value: string) => {
  if (!new RegExp("^\\d{8}$").test(value)) {
    return false;
  }

  let a = 0;
  const b = value.split("");
  for (let i = 0; i < 7; i += 1) {
    // @ts-expect-error length checked within regex
    const bValue: string = b[i];
    a += parseInt(bValue, 10) * (8 - i);
  }
  a %= 11;
  let c = 11 - a;
  if (a === 1) {
    c = 0;
  } else if (a === 0 || a === 10) {
    c = 1;
  }

  // @ts-expect-error length checked within regex
  const bLast: string = b[7];
  return parseInt(bLast, 10) === c;
};

export const isDicValid = (value: string) => {
  const id = value.substring(0, 2).toUpperCase();
  const numValue = value.substring(2);
  if (id === "CZ" || id === "SK") {
    if (numValue.length < 8 || numValue.length > 11) {
      return false;
    }
    if (numValue.length === 8) {
      return isIcoValid(numValue);
    }
    return rodnecislo(numValue).isValid();
  }
  return false;
};

export const getTradesmanValidations = (t: TFunction<"validations">) => ({
  orgId: (value: string) => (isIcoValid(value) ? null : t("invalidOrgId")),
  vatId: (value: string) => (value === "" ? t("requiredVatId") : isDicValid(value) ? null : t("invalidVatId")),
  personalNumber: (value: string | null) => (value !== null && rodnecislo(value).isValid() ? null : t("invalidPersonalNumber")),
});

export const getCompanyValidations = (t: TFunction<"validations">) => ({
  name: (value: string | null) => lenCheck(value, 3, 120, t("tooShortCompany"), t("tooShortCompany"), t("tooLongCompany")),
});

export const getExecutivePeopleValidations = (t: TFunction<"validations">) => ({
  executiveRoleId: (value: string | null) => {
    return !value ? t("requiredExecutiveRole") : null;
  },
});
